import React from "react"
import ReactDOM from "react-dom/client"
import { ConfigProvider } from "antd"
import { BrowserRouter } from "react-router-dom"
import { HelmetProvider } from "react-helmet-async"
import App from "./App"
import "./index.css"

// Theme colours sampled from the logo artwork (frontend/public/logo.png).
// The previous values (#f26522 / #0066b3) were labelled as coming from the logo
// but did not match it — the orange was redder and the blue lighter than the
// mark. These are the two dominant hues in the file.
const BRAND_ORANGE = "#F3992E"
const BRAND_BLUE = "#1B559E"

const theme = {
  token: {
    colorPrimary: BRAND_ORANGE,
    colorLink: BRAND_BLUE,
    colorSuccess: "#52c41a",
    colorWarning: "#faad14",
    colorError: "#f5222d",
    colorInfo: BRAND_BLUE,
    borderRadius: 4,
  },
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HelmetProvider>
      <ConfigProvider theme={theme}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ConfigProvider>
    </HelmetProvider>
  </React.StrictMode>,
)

